var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.getters.isEnterprise)?_c('enterprise-startup'):_vm._e(),(_vm.$store.getters.isEcosystem)?_c('ecosystem-startup'):_vm._e(),(!_vm.$store.getters.isLoggedIn)?_c('public-startup'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }